import React from "react";
import ReactDOM from "react-dom/client";

// Show minimal loading state immediately
const root = ReactDOM.createRoot(document.getElementById("root")!);

// Lazy load the main app bundle
const loadApp = async () => {
  // Load MDS and app resources
  const [{ default: App }, { MdsConfig }, { initTheme }] = await Promise.all([
    import("./App.tsx"),
    import("@maersk-global/mds-config"),
    import("./utils/theme"),
    // Load MDS foundations and global styles
    import("@maersk-global/mds-foundations/css/foundations.css"),
    import("./styles/globals.css"),
    import("./styles/layout.css"),
    // A3 platform design tokens & app shell — loaded last so it wins on overlap
    import("./styles/a3-platform.css"),
  ]);

  initTheme();

  // Configure icons path for MDS components
  MdsConfig.iconsDynamicImportPath = import.meta.env.DEV
    ? "/node_modules/"
    : "/assets/node_modules/";

  // Render the full app
  root.render(
    <React.StrictMode>
      <a href="#main-content" className="mds-skip-to">
        Skip to content
      </a>
      <a href="#footer" className="mds-skip-to">
        Skip to footer
      </a>
      <App />
    </React.StrictMode>
  );
};

// Start loading the app
loadApp().catch(console.error);
